/* eslint-disable no-undef */
import "bootstrap/dist/css/bootstrap.min.css";
import "assets/scss/material-dashboard-pro-react.scss?v=1.10.0";

import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { AuthClientTokens } from "@react-keycloak/core";

import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import App from "App";
import LoadingScreen from "components/UtilsComponent/LoadingScreen";
import keycloak from "configs/keycloak";
import "./i18n";
import { KeycloakInitOptions } from "keycloak-js";
import { Logger } from "helpers/LogHelper";
import { ErrorBoundary } from "components/ErrorBoundary";
import apiInputService from "services/apiInputService";

import "./styles/globalUploadButtonFiles.css";
import ConfigQueryClient from "ConfigQueryClient";
import GlobalAlert from "components/GobalAlert/GobalAlert";

import { ThemeProvider } from "@mui/material/styles";
import customTheme from "./styles/theme";

const token = localStorage.getItem("accessToken");
const refreshToken = localStorage.getItem("refreshToken");

const isTokenValid =
  token &&
  refreshToken &&
  token !== "undefined" &&
  refreshToken !== "undefined";

const initOptions: KeycloakInitOptions = isTokenValid
  ? {
      token,
      refreshToken,
      checkLoginIframe: false,
      onLoad: "check-sso",
    }
  : undefined;

const saveTokens = (tokens: AuthClientTokens) => {
  localStorage.setItem("accessToken", tokens?.token || "");
  localStorage.setItem("refreshToken", tokens?.refreshToken || "");
  apiInputService.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${tokens?.token}`;
};

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <ReactKeycloakProvider
      authClient={keycloak}
      LoadingComponent={<LoadingScreen />}
      initOptions={initOptions}
      onEvent={(event, error) => {
        error && Logger("onKeycloakEvent", event, error);
      }}
      onTokens={saveTokens}
    >
      <BrowserRouter>
        <ThemeProvider theme={customTheme}>
          <ConfigQueryClient>
            <ErrorBoundary>
              <GlobalAlert />
              <App />
            </ErrorBoundary>
            <ReactQueryDevtools initialIsOpen={false} />
          </ConfigQueryClient>
        </ThemeProvider>
      </BrowserRouter>
    </ReactKeycloakProvider>,
  );
}
